import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { Formik } from "formik";
import TextField from "@material-ui/core/TextField";
import { Row, Col } from "react-flexbox-grid";
import LinearProgress from "@material-ui/core/LinearProgress";

const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500]
  }
}))(props => {
  const { children, classes, onClose, loading } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
          disabled={loading}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const styles = theme => ({
  margin: {
    margin: theme.spacing.unit * 2
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  fileZone: {
    borderWidth: 2,
    borderColor: "#DCDCDC",
    borderStyle: "dashed",
    borderRadius: 5,
    margin: theme.spacing.unit * 2
  }
});

class AddFileModal extends Component {
  state = {
    filename: undefined
  };

  render() {
    const {
      opened,
      classes,
      onClose,
      onSubmit,
      loading,
      error
    } = this.props;
    return (
      <Dialog
        onClose={onClose}
        aria-labelledby="upload-file-dialog"
        open={opened}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle
          id="upload-file-dialog-title"
          onClose={onClose}
          loading={loading}
        >
          Cargar un archivo
        </DialogTitle>
        <Formik
          initialValues={{
            file: null,
            name: ""
          }}
          onSubmit={(values, { resetForm }) => {
            const { file, name } = values;
            onSubmit({ variables: { file, name } }).then(() => {
              resetForm();
              onClose();
            });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            handleChange,
            setFieldValue
          }) => {
            return (
              <form onSubmit={handleSubmit}>
                <DialogContent>
                  <DialogContentText>
                    Selecciona el archivo que deseas subir...
                  </DialogContentText>
                  <Row center="xs">
                    <Col xs>
                      <TextField
                        id="outlined-name"
                        label="Nombre"
                        name="name"
                        className={classes.textField}
                        value={values.name}
                        onChange={handleChange}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        disabled={loading}
                      />
                    </Col>
                  </Row>
                  <Row center="xs">
                    <Col xs>
                      <div className={classes.fileZone}>
                        <input
                          className={classes.input}
                          style={{ display: "none" }}
                          id="raised-button-file"
                          type="file"
                          onChange={({
                            target: {
                              files: [file]
                            }
                          }) => {
                            setFieldValue("file", file);
                          }}
                        />
                        <label htmlFor="raised-button-file">
                          <Button
                            size="large"
                            variant="contained"
                            component="span"
                            className={classes.margin}
                            disabled={loading}
                          >
                            Seleccionar archivo...
                            <CloudUploadIcon className={classes.rightIcon} />
                          </Button>
                        </label>
                        {errors.file && touched.file && <p>{errors.file}</p>}
                        <Typography variant="body1">
                          {values.file
                            ? `Seleccionado: ${values.file.name}`
                            : "Ningun archivo seleccionado ..."}
                        </Typography>
                      </div>
                    </Col>
                  </Row>
                  <Row center="xs">
                    <Col xs>
                      <DialogContentText>
                        {error && <p>Error :( Por favor intenta de nuevo</p>}
                      </DialogContentText>
                    </Col>
                  </Row>
                  <Row center="xs">
                    <Col xs>
                      {loading ? (
                        <div>
                          <LinearProgress />
                          <DialogContentText>Cargando ...</DialogContentText>
                        </div>
                      ) : null}
                    </Col>
                  </Row>
                </DialogContent>
                <DialogActions>
                  <Button onClick={onClose} color="primary" disabled={loading}>
                    Cancelar
                  </Button>
                  <Button type="submit" color="primary" disabled={loading}>
                    Subir archivo
                  </Button>
                </DialogActions>
              </form>
            );
          }}
        </Formik>
      </Dialog>
    );
  }
}

export default withStyles(styles)(AddFileModal);



// WEBPACK FOOTER //
// ./src/components/files/addFileModal.js